import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { checkAndLoginIfInactive } from '../../utils/check';

const IdleChecker = ({ idleTimeThreshold, activeTimeThreshold = 18000 }) => {
  const [isIdle, setIsIdle] = useState(false);

  useEffect(() => {
    let idleTimer;

    const resetIdleTimer = () => {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(() => {
        setIsIdle(true);
      }, idleTimeThreshold); // Adjust the idle time threshold as needed (in milliseconds)
    };

    const handleUserActivity = () => {
      setIsIdle(false);
      resetIdleTimer();
    };

    // Attach event listeners for user activity
    window.addEventListener('mousemove', handleUserActivity);
    window.addEventListener('keydown', handleUserActivity);
    window.addEventListener('touchstart', handleUserActivity);

    // Initial setup
    resetIdleTimer();

    // Clean up event listeners on component unmount
    return () => {
      clearTimeout(idleTimer);
      window.removeEventListener('mousemove', handleUserActivity);
      window.removeEventListener('keydown', handleUserActivity);
      window.removeEventListener('touchstart', handleUserActivity);
    };
  }, [idleTimeThreshold]);

  useEffect(() => {
    let activeTimer;
    const setActiveTimer = () => {
      clearInterval(activeTimer);
      activeTimer = setInterval(() => {
        checkAndLoginIfInactive();
      }, activeTimeThreshold);
    };
    // Perform actions when the user transitions from idle to active
    if (!isIdle) {
      // Trigger your function here
      setActiveTimer();
      checkAndLoginIfInactive();
    }

    return () => {
      clearInterval(activeTimer);
    };
  }, [isIdle, activeTimeThreshold]);

  useEffect(() => {
    localStorage.removeItem('checkTokenLocalStorageLock');
    return () => {
      localStorage.removeItem('checkTokenLocalStorageLock');
    };
  }, []);

  return null;
};

IdleChecker.propTypes = {
  idleTimeThreshold: PropTypes.number.isRequired,
  activeTimeThreshold: PropTypes.number,
};

export default IdleChecker;
